import React, { useContext } from 'react'
import CheckBox from './CheckBox'
import Input from './Input'
import Select from './Select'
import Description from './Description'
import Note from './Note'
import FileUpload from './FileUpload'
import TextArea from './TextArea'
import RadioBtn from './RadioBtn'
import { FormContext } from '../../FormContext'
import Line from './Line'
import CheckBoxes from './CheckBoxes'

const Element = ({ field: { field_filename, field_multiple_index, field_multiple_primary, field_align, field_invisible, field_disabled_approver, field_column, field_autocomplete, field_id, field_label, field_type, field_placeholder, field_options, options, field_mandatory, field_value, field_disabled, field_date_depend, field_number_max, field_number_min, field_multiple, field_multiple_id,field_multiple_type,field_date_min,field_date_max, field_price }, isPageUser, custom_at_user 
  }) => {
   
  console.log('element field date max min;',field_date_max,field_date_min)
 
  const { disableField, formAdmin, formOfficer } = useContext(FormContext);
  let disable_field = field_disabled || disableField
  formAdmin && (disable_field = false);
  !isPageUser && (disable_field = true);
  custom_at_user && (disable_field = true);
  // let field_visible = Math.random()>0.5?true:false
  if (!field_invisible) {
    switch (field_type) {
      case 'text':
      case 'email':
      case 'date':
      case 'time':
      case 'number':
        return (
          <Input

            field_disabled_approver={field_disabled_approver}
            field_column={field_column}
            field_id={field_id}
            field_label={field_label}
            field_type={field_type}
            field_mandatory={field_mandatory}
            field_placeholder={field_placeholder}
            field_value={field_value}
            field_autocomplete={field_autocomplete}
            field_disabled={disable_field}
            field_date_depend={field_date_depend}
            field_number_min={field_number_min}
            field_number_max={field_number_max}
            field_date_min={field_date_min}
            field_date_max={field_date_max}
            field_multiple={field_multiple}
            field_multiple_primary={field_multiple_primary}
            field_multiple_id={field_multiple_id}
            field_multiple_type={field_multiple_type}
            field_price={field_price}
          />);
      case 'select':
        return (
          <Select
            field_disabled_approver={field_disabled_approver}
            field_column={field_column}
            field_id={field_id}
            field_label={field_label}
            field_type={field_type}
            field_options={field_options}
            options={options}
            field_mandatory={field_mandatory}
            field_value={field_value}
            field_disabled={disable_field}
            field_multiple={field_multiple}
            field_multiple_primary={field_multiple_primary}
            field_multiple_id={field_multiple_id}
            field_multiple_index={field_multiple_index}
            field_multiple_type={field_multiple_type}
          />
        )
      case 'checkbox':
        return (<CheckBox
          field_column={field_column}
          field_id={field_id}
          field_label={field_label}
          field_type={field_type}
          field_value={field_value}
          field_disabled={disable_field}
          field_mandatory={field_mandatory}
          field_multiple_type={field_multiple_type}
          field_multiple_id={field_multiple_id}
          field_disabled_approver={field_disabled_approver}

        />)
      case 'checkboxes':
        // return (<p>Checkboxes</p>)
        return (<CheckBoxes
          field_column={field_column}
          field_id={field_id}
          field_label={field_label}
          field_type={field_type}
          field_options={field_options}
          options={options}
          field_mandatory={field_mandatory}
          field_value={field_value}
          field_disabled={disable_field}
          field_align={field_align}

        />)
      case 'description':
        return (<Description
          field_column={field_column}
          field_label={field_label}
          field_disabled={disable_field}

        />)
      case 'note':
        return (<Note
          field_column={field_column}
          field_label={field_label}
          field_disabled={disable_field}

        />)

      case 'upload':
        return (<FileUpload
          field_multiple_id={field_multiple_id}
          field_disabled_approver={field_disabled_approver}
          field_column={field_column}
          field_id={field_id}
          field_label={field_label}
          field_mandatory={field_mandatory}
          field_value={field_value}
          field_disabled={disable_field}
          field_multiple={field_multiple}
          field_multiple_primary={field_multiple_primary}
          field_multiple_type={field_multiple_type}
          field_filename={field_filename}

        />)

      case 'textarea':
        return (<TextArea
          field_disabled_approver={field_disabled_approver}
          field_column={field_column}
          field_id={field_id}
          field_label={field_label}
          field_mandatory={field_mandatory}
          field_placeholder={field_placeholder}
          field_value={field_value}
          field_disabled={disable_field}
          field_multiple_id={field_multiple_id}
          field_multiple_type={field_multiple_type}

        />)
      case 'radio':
        return (<RadioBtn
          field_column={field_column}
          field_id={field_id}
          field_disabled={disable_field}
          field_label={field_label}
          field_mandatory={field_mandatory}
          field_options={field_options}
          field_value={field_value}
          field_multiple_type={field_multiple_type}
          field_multiple_id={field_multiple_id}
          field_disabled_approver={field_disabled_approver}
          field_align={field_align}
        />)

      case 'line':
        return (<Line
          field_column={field_column}

        />)


      default:
        return null;


    }
  } else {
    return null;
  }


}

export default Element

